export const url =
  window &&
  window.location &&
  `${window.location.protocol}//${window.location.hostname}`;

export const configMap = {
  // LOCAL
  "https://local-apps.axahealth.intraxa":
    "https://local-apps.axahealth.intraxa:44400",
  "https://dev-apps.health-on-line.intraxa":
    "https://dev-apps.health-on-line.intraxa:44400",
  "http://localhost": "http://localhost:13606",
  "https://localhost": "https://localhost:44400",

  // DV
  "https://osspa-web-dv.z-ppp-dv-ase01.xpzcloud.com":
    "https://osexternal-api-dv.z-ppp-dv-ase01.xpzcloud.com",
  "https://osspa-web-dv-axa.z-ppp-dv-apps.xpzcloud.com":
    "https://osexternal-api-dv-axa.z-ppp-dv-apps.xpzcloud.com",
  "https://osspa-web-dv-hol.z-ppp-dv-apps.xpzcloud.com":
    "https://osexternal-api-dv-hol.z-ppp-dv-apps.xpzcloud.com",

  // QA
  "https://osspa-web-qa.z-ppp-dv-ase01.xpzcloud.com":
    "https://osexternal-api-qa.z-ppp-dv-ase01.xpzcloud.com",
  "https://osspa-web-qa-axa.z-ppp-dv-apps.xpzcloud.com":
    "https://osexternal-api-qa-axa.z-ppp-dv-apps.xpzcloud.com",
  "https://osspa-web-qa-hol.z-ppp-dv-apps.xpzcloud.com":
    "https://osexternal-api-qa-hol.z-ppp-dv-apps.xpzcloud.com",

  // PP
  "https://osspa-web-pp.z-ppp-pp-ase01.xpzcloud.com": `https://osexternal-api-pp.z-ppp-pp-ase01.xpzcloud.com`,
  "https://apps.onlineapps.pp.axahealth.co.uk": `https://osapi.onlineapps.pp.axahealth.co.uk`,
  "https://pp-app.health-on-line.co.uk": `https://pp-osapi.health-on-line.co.uk`,

  // PR
  "https://osspa-web-pr.z-ppp-pr-ase01.xpzcloud.com": `https://osexternal-api-pr.z-ppp-pr-ase01.xpzcloud.com`,
  "https://apps.axahealth.co.uk": `https://osapi.onlineapps.axahealth.co.uk`,
  "https://apps.health-on-line.co.uk": `https://osapi.health-on-line.co.uk`,

  // DR
  "https://osspa-web-dr.z-ppp-pp-ase01.xpzcloud.com": `https://osexternal-api-dr.z-ppp-pp-ase01.xpzcloud.com`,
  "https://apps.onlineapps.dr.axahealth.co.uk": `https://osapi.onlineapps.dr.axahealth.co.uk`,
  "https://dr-app.health-on-line.co.uk": `https://dr-osapi.health-on-line.co.uk`
};

export let backendHost = configMap[url];
export const API_ROOT = `${backendHost}/api`;
